import type { T_Maybe } from '@tryiris-ai/js-types';
import { toEnum } from '@tryiris-ai/js-types';
import { Tab } from './types.js';

/**
 * Transforms the specified value to a `Tab` enumeration.
 *
 * @param value - The value to be transformed.
 * @returns The transformed `Tab` enumeration or `undefined`.
 */
export const toTab = (value: unknown): T_Maybe<Tab> => toEnum(Tab, value);
